export default __webpack_public_path__ + "fonts/Open-24-Display-St.ttf.woff";